import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=5b9fbbb4&scoped=true&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9fbbb4",
  null
  
)

export default component.exports